export default function() {
    return {
        events: [],
        currentPage: 1,
        totalPages: 0,
        itemsPerPage: 15,
        searchParams: {
            name: null,
            'user.company.cnpj': null,
            'createdAt[after]': null,
            'createdAt[before]': null,
            'order.status': null,
            'exists[order]': null
        },
        fields: [
            {
                key: 'name',
                label: 'Título'
            },
            {
                key: 'status',
                label: 'Status'
            },
            {
                key: 'start',
                label: 'Data Início'
            },
            {
                key: 'end',
                label: 'Data Fim'
            },
            {
                key: 'totalDays',
                label: 'Duração'
            },
            {
                key: 'user',
                label: 'Contratante'
            },
            {
                key: 'actions',
                label: 'Ações'
            }
        ],
        eventStatusLabels: {
            'creating': 'Em criação',
            'pending_payment': 'Aguardando pagamento',
            'paid': 'Pago',
            'cancelled': 'Cancelado'
        },
        orderStatusOptions: [
            {
                label: 'Todos',
                value: null
            },
            {
                label: 'Em criação',
                value: 'creating'
            },
            {
                label: 'Aguardando pagamento',
                value: 'pending_payment'
            },
            {
                label: 'Pago',
                value: 'paid'
            },
            {
                label: 'Cancelado',
                value: 'cancelled'
            }
        ]
    }
}

